import theme from "@/foundation/Theme";

const mapHeroSectionData = (webinarData) => {
  const heroData = webinarData?.hero;
  const data = {};

  data.title = heroData?.hero_title;
  data.subtitle = heroData?.hero_subtitle;
  data.primaryBtnText = heroData?.hero_signup_primary_cta;
  data.secondaryBtnText = heroData?.hero_signup_secondary_cta;
  data.tag = heroData?.tag || "WEBINARS";

  return data;
};

const mapUpcomingWebinarData = (webinarData) => {
  const data = {};

  data.showWebinarList =
    webinarData?.webinar_list?.upcoming_webinars?.length > 0;

  return data;
};

export const mapDoctorList = (doctorData) => {
  const data = {};

  data.name = doctorData?.name;
  data.src = doctorData?.image;
  data.highlights = doctorData?.highlights;

  return data;
};

const mapPastWebinarCardData = (webinar) => {
  const data = {};

  data.id = webinar?.id;
  data.title = webinar?.title;
  data.date = webinar?.date;
  data.time = webinar?.time;
  data.thumbnail = webinar?.thumbnail_image;
  data.channelLogo =
    "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-06/shyft-yt-logo-87d075e5038c4c238373b17e29c6fe40.jpg";
  data.videoDuration = "1 Hr 05 mins";
  data.videoUrl = webinar?.video_url;
  data.startTime = webinar?.video_start_time || 0;
  data.endTime = webinar?.video_end_time || 30;
  data.buttonText = webinar?.cta_title || "Watch the Webinar";
  data.doctorList = webinar?.trainer_details?.map((doctor) =>
    mapDoctorList(doctor)
  );

  return data;
};

const mapPastWebinarData = (webinarData) => {
  const data = {};

  data.showPastWebinarList =
    webinarData?.webinar_list?.past_webinars?.filter(
      (webinar) => !!webinar.video_url
    )?.length > 0;
  data.sectionHeading = "Watch Past Webinars"; //TODO: make dynamic in future
  data.sectionHeadingColor = theme.colorsV2.shyft.purple_text;
  data.pastWebinarList = webinarData?.webinar_list?.past_webinars
    ?.filter((webinar) => !!webinar?.video_url)
    ?.map((webinar) => mapPastWebinarCardData(webinar));

  return data;
};

const mapBottomFormData = (formData) => {
  const bottomFormData =
    (Array.isArray(formData?.forms)
      ? formData?.forms?.find((form) => form.name === "webinar listing form")
      : formData?.forms) || {};

  const data = {};

  // Left Section
  data.title = bottomFormData?.bottom_title || "Ready to make the Shyft ?";
  data.description = bottomFormData?.description || "Say farewell to unwell";
  data.subtitle =
    bottomFormData?.bottom_sub_title ||
    "Fill the form and our Team will get back to you within 24 hrs.";
  data.number =
    bottomFormData?.number || `+91-${process.env.NEXT_PUBLIC_CONTACT_NUMBER}`;
  data.email = bottomFormData?.email || "hello@betheshyft.com";

  // Right Section
  data.services = bottomFormData?.services || [];
  data.namePlaceholder = bottomFormData?.first_name_text || "Your Name";
  data.emailPlaceholder = bottomFormData?.contact_email_text || "Your Email";
  data.phonePlaceholder = bottomFormData?.contact_number_text || "Your Phone";
  data.buttonText = bottomFormData?.button_text || "Submit";
  data.dropdown = bottomFormData?.dropdown || [];

  // SuccessModal
  data.successImage = bottomFormData?.image;
  data.submissionTitle = bottomFormData?.submission_title;
  data.submissionSubtitle = bottomFormData?.submission_subtitle;
  data.submissionExtraText = bottomFormData?.submission_extra_text;

  data.defaultSlug = formData?.hero?.hero_signup_primary_pricing?.package_slug;

  return data;
};

export const mapRegisterModalData = (_modalData, webinarData) => {
  const getName = (type) => {
    if (type === "NEW_WEBINAR_REQUEST") {
      return "new webinar request form";
    }
    if (type === "WATCH_WEBINAR_REQUEST") {
      return "watch full webinar form";
    }
    if (type === "WATCH_RECORDED_WEBINAR_REQUEST") {
      return "	watch recorded webinar form";
    }
  };

  const modalData = webinarData?.forms?.find(
    (form) => form.name === getName(_modalData?.type)
  );

  const data = {};

  data.title =
    modalData?.title || "Register now to watch the complete webinar.";
  data.subTitle = modalData?.sub_title;
  data.buttonText = modalData?.buttonCTA || "Close";
  data.packageSlug =
    webinarData?.hero?.hero_signup_primary_pricing?.package_slug;
  data.successImage = modalData?.image;
  data.submissionTitle = modalData?.submission_title;
  data.submissionSubtitle = modalData?.submission_subtitle;
  data.submissionExtraText = modalData?.submission_extra_text;

  return data;
};

export const mapWebinarData = (webinarData) => {
  const data: any = {};

  data.heroSectionData = mapHeroSectionData(webinarData);
  data.upcomingWebinarData = mapUpcomingWebinarData(webinarData);
  data.pastWebinarData = mapPastWebinarData(webinarData);
  data.bottomFormData = mapBottomFormData(webinarData);

  return data;
};
